var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3F6DB2",
  fillRule: "evenodd",
  d: "M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2Zm7 7V1.5L14.5 7H9Z",
  clipRule: "evenodd"
})));
export { SvgFile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAwQzAuOSAwIDAuMDEgMC45IDAuMDEgMkwwIDE4QzAgMTkuMSAwLjg5IDIwIDEuOTkgMjBIMTRDMTUuMSAyMCAxNiAxOS4xIDE2IDE4VjZMMTAgMEgyWk05IDdWMS41TDE0LjUgN0g5WiIgZmlsbD0iIzNGNkRCMiIvPgo8L3N2Zz4K";